var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isFull168)?_c(_setup.Full168):_c(_setup.Full)
}
var staticRenderFns = []

export { render, staticRenderFns }